<div class="resultsContainerSmall" *ngIf="resultObject.hasResults">
  <div align="center">
      <input type="text" size="15" maxlength="15" [(ngModel)]="accountNbr" placeholder="Account #" autofocus>
      <button icon="fa fa-search" pButton (click)="searchByAccountNbr();"></button>
      <button icon="fa fa-times" pButton (click)="clearSearchByAccountNbr();"></button>
  </div>
  <p-table #dt [columns]="resultObject.displayColumns"
           [value]="uniqueAccounts"
           [paginator]="true" [rows]="tableRows" pageLinks="3" selectionMode="single" [(first)]="first">
    <ng-template pTemplate="caption">{{uniqueAccounts?.length}} accounts</ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th  [pSortableColumn]="resultObject.displayColumns[0].sortName" [ngStyle]="{'width':'100px'}">
          {{resultObject.displayColumns[0].label}}
          <p-sortIcon [field]="resultObject.displayColumns[0].sortName"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [style.background-color]="rowIndex == indexRow ? 'grey':''" (click)="shortListTableClickHandler(row)">
        <td [title]="row.primary_address_street_address">
          <div style="font-weight: bold; color: green">{{ row.account_number }}</div>
          <div *ngIf="row?.primary_address_street_address?.length > 0; else noaddress">{{ row.primary_address_street_address | truncate:15 }}</div>
          <ng-template #noaddress>
            <div>No Address</div>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
